import { render, staticRenderFns } from "./storeBuyerMarketingStat.vue?vue&type=template&id=79b1a36e&"
import script from "./storeBuyerMarketingStat.vue?vue&type=script&lang=js&"
export * from "./storeBuyerMarketingStat.vue?vue&type=script&lang=js&"
import style0 from "./storeBuyerMarketingStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports